import { render, staticRenderFns } from "./GuideBookPaperSmallCard.vue?vue&type=template&id=51730b42"
import script from "./GuideBookPaperSmallCard.vue?vue&type=script&lang=js"
export * from "./GuideBookPaperSmallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports